/**
 * We will increment this by 1 if there
 * are any quote breaking changes in our state
 */
export const quoteVersion = 2;
